import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-master-questionedit',
  templateUrl: './blog-master-questionedit.component.html',
  styleUrls: ['./blog-master-questionedit.component.scss']
})
export class BlogMasterQuestioneditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
